export default {
  listMailTemplate: [],
}